const requestActionTypes = {
  RESET_STATE: 'RESET_STATE',
  REQUEST_RESET_PASSWORD_REQUEST: 'REQUEST_RESET_PASSWORD_REQUEST',
  REQUEST_RESET_PASSWORD_SUCCESS: 'REQUEST_RESET_PASSWORD_SUCCESS',
  REQUEST_RESET_PASSWORD_FAILURE: 'REQUEST_RESET_PASSWORD_FAILURE',
};

export { requestActionTypes as default };
